const CircularSkeletonLoader = ({
  size = "48px",
  className = "",
  count = 1,
  spacing = "16px",
  layout = "vertical",
}) => {
  return (
    <div
      className={`circular-skeleton-container ${layout} ${className}`}
      style={{ gap: spacing }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="skeleton-circle"
          style={{
            width: size,
            height: size,
            animationDelay: `${index * 0.4}s`,
          }}
        >
          <div
            className="skeleton-shimmer-circular"
            style={{
              animationDelay: `${index * 0.2}s`,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default CircularSkeletonLoader;
